import axios from "axios";
import { BASE_URL } from "../../Config/BaseUrl";
const token = localStorage.getItem("token");

const createAxiosConfig = (url, method, data) => {
  return {
    method,
    url: `${BASE_URL}${url}`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data,
  };
};

const StudentsListAPI = {
  getStudentProfile: async (data) => {
    const axiosConfig = createAxiosConfig(
      "get_StudentProfileInfo/",
      "POST",
      data
    );
    return await axios(axiosConfig);
  },
  getStudentsList: async (data) => {
    const axiosConfig = createAxiosConfig("get_SchoolWiseStudentList/", "POST", data);
    return await axios(axiosConfig);
  },
};

export default StudentsListAPI;
